import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

// NYC bounding box to bias results
const NYC_VIEWBOX = "-74.2591,40.9176,-73.7002,40.4774";

export function GeoSearch({ onPick }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);

  const search = async (e) => {
    e?.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    setNoResults(false);
    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&limit=5&bounded=1&viewbox=${NYC_VIEWBOX}&q=${encodeURIComponent(q + ", New York")}`;
      const res = await fetch(url, { headers: { "Accept-Language": "en" } });
      const data = await res.json();
      setResults(data);
      setNoResults(data.length === 0);
    } catch {
      setResults([]);
      setNoResults(true);
    } finally {
      setLoading(false);
    }
  };

  const choose = (r) => {
    onPick(parseFloat(r.lat), parseFloat(r.lon), r.display_name.split(",").slice(0, 2).join(","));
    setResults([]);
    setNoResults(false);
    setQ(r.display_name.split(",").slice(0, 2).join(","));
  };

  return (
    <div className="relative">
      <form onSubmit={search} className="flex gap-2">
        <Input data-testid="geo-search-input" value={q} onChange={(e) => setQ(e.target.value)}
          className="bg-white border-stone-200" placeholder="Search a NYC place e.g. SoHo, Central Park…" />
        <Button data-testid="geo-search-btn" type="submit" variant="outline" className="border-stone-300 gap-2 shrink-0">
          {loading ? <Loader2 className="animate-spin" size={16} /> : <Search size={16} />}
        </Button>
      </form>
      {results.length > 0 && (
        <div className="absolute z-[1000] mt-1 w-full bg-white border border-stone-200 rounded-xl shadow-lg overflow-hidden" data-testid="geo-search-results">
          {results.map((r, i) => (
            <button key={i} type="button" onClick={() => choose(r)}
              className="w-full text-left px-4 py-2.5 text-sm text-stone-700 hover:bg-amber-50 transition-colors border-b border-stone-100 last:border-0">
              {r.display_name}
            </button>
          ))}
        </div>
      )}
      {noResults && (
        <p className="text-xs text-stone-500 mt-1.5" data-testid="geo-search-empty">No matches found — try another search or tap the map to drop your point.</p>
      )}
    </div>
  );
}
